import { TnplContractSchema } from "@redotech/redo-tnpl-common/tnpl-contract";
import { TnplContractTemplateSchema } from "@redotech/redo-tnpl-common/tnpl-contract-template";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

const getTnplContractStatusOutput = z.object({
  contract: TnplContractSchema,
  template: TnplContractTemplateSchema,
});

export type TnplContractWithTemplate = z.infer<
  typeof getTnplContractStatusOutput
>;

export const getTnplContractStatus = {
  name: "getTnplContractStatus" as const,
  input: z.object({ orderId: zExt.objectId() }),
  output: getTnplContractStatusOutput,
};
